import { render, staticRenderFns } from "./img-zoom.vue?vue&type=template&id=70205904&scoped=true"
import script from "./img-zoom.vue?vue&type=script&lang=js"
export * from "./img-zoom.vue?vue&type=script&lang=js"
import style0 from "./img-zoom.vue?vue&type=style&index=0&id=70205904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70205904",
  null
  
)

export default component.exports